import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import secureLink from '@utils/secureLink'
import Link from 'next/link'
import { getFacilityName, getFacilityAddress } from '@utils/algoliaFacilityUtils'
import useStyles from './coach-card-version-3.styles'
import initials from '@utils/initials'
import { gtmEvent } from '@lib/gtm-utils'

const CoachCardVersion3 = (props) => {
  const {
    hit,
    coachCardClass,
    source
  } = props
  const styles = useStyles()
  const facilityAddress = getFacilityAddress(hit.facilities)
  const facilityName = getFacilityName(hit.facilities)

  return (
    <Box
      display="flex"
      justifyContent="flex-start"
      className={`${styles.cardWrapper} ${coachCardClass}`}
      onClick={() => gtmEvent({
        event: 'click-coach-card',
        attributes: {
          bookable: hit.bookable,
          coach_name: (hit.firstName && hit.lastName)
            ? `${hit.firstName} ${hit.lastName}`
            : `${hit.displayName}`,
          coach_profile_id: hit.objectID,
          has_video: hit.hasIntroVideo,
          source: source,
        },
      })}
    >
      <Box display="flex" flexDirection="column" justifyContent="center" mr={[2]}>
        <Typography variant="overline" className={styles.location}>{facilityAddress}</Typography>
        <Typography variant="h5" className={styles.displayName}>{`${hit.firstName} ${hit.lastName}`}</Typography>
        <Typography variant="body1" className={styles.facility}>{facilityName}</Typography>
        <Link href={`/coach/${hit.customSlug}`} passHref>
          <a className={styles.linkButton}>View Profile</a>
        </Link>
      </Box>
      <Box style={{ marginLeft: 'auto' }}>
        <Avatar
          aria-label="coach"
          className={styles.avatar}
          src={secureLink(hit.profilePhoto)}
        >
          {!hit.profilePhoto && initials(hit.firstName, hit.lastName)}
        </Avatar>
      </Box>
    </Box>
  )
}

CoachCardVersion3.propTypes = {
  hit: PropTypes.object,
  coachCardClass: PropTypes.string,
  source: PropTypes.string,
}

CoachCardVersion3.defaultProps = {
  coachCardClass: '',
}

export default CoachCardVersion3
